import { AxiosPromise } from 'axios';
import Api from '../../configs/AxiosConfig';
import {
  ActiveBannersResponse,
  BannerOverlapsRequest,
  BannerOverlapsResponse,
  BannerRequest,
  BannerResponse,
  BannersListRequest,
  BannersListResponse,
} from '../../models/BannersModels';

const BannersService = {
  api: {
    fetchActiveBanners: (): AxiosPromise<ActiveBannersResponse> => Api.get('/notifications/banner/active'),
    fetchBanners: (params: BannersListRequest): AxiosPromise<BannersListResponse> =>
      Api.post('/notifications/banner/list', params),
    fetchBannerById: (id: string): AxiosPromise<BannerResponse> => Api.get(`/notifications/banner/${id}`),
    createBanner: (params: BannerRequest): AxiosPromise<BannerResponse> => Api.post('/notifications/banner', params),
    updateBanner: (id: string, params: BannerRequest): AxiosPromise<BannerResponse> =>
      Api.post(`/notifications/banner/${id}/update`, params),
    checkBannerOverlaps: (params: BannerOverlapsRequest): AxiosPromise<BannerOverlapsResponse> =>
      Api.post('/notifications/banner/overlaps', params),
    cancelBanner: (id: string): AxiosPromise<BannerResponse> => Api.post(`/notifications/banner/${id}/cancel`),
    deleteBanner: (id: string): AxiosPromise<BannerResponse> => Api.delete(`/notifications/banner/${id}`),
  },
};

export default BannersService;
